import { render, staticRenderFns } from "./CreateRelation.vue?vue&type=template&id=3e159998"
import script from "./CreateRelation.vue?vue&type=script&lang=js"
export * from "./CreateRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports